module.exports = __webpack_public_path__ + "static/img/qml-pay-2@2x.3bf595f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app/qml/pay/img/qml-pay-2@2x.png
// module id = m6OD
// module chunks = 1